const ClientType = Object.freeze({
    HEALTH_SYSTEM: 'HEALTH SYSTEM',
    HOSPITAL: 'HOSPITAL',
    DEPARTMENT: 'DEPARTMENT',
    PROVIDER: 'PROVIDER', 
    PHYSICIANS_GROUP: 'PHYSICIANS GROUP',
    UNDEFINED: "USER_NOT_DEFINED" 
})

const userTypeToEnumMapping = Object.freeze({
    'HEALTH SYSTEM': ClientType.HEALTH_SYSTEM,
    'HOSPITAL': ClientType.HOSPITAL,
    'DEPARTMENT': ClientType.DEPARTMENT,
    'PROVIDER': ClientType.PROVIDER,
    'PHYSICIANS GROUP': ClientType.PHYSICIANS_GROUP
})

const userTypeToDictionaryKeyMapping = Object.freeze({
    'HEALTH SYSTEM': 'health_system_id',
    'HOSPITAL': 'hospital_id',
    'DEPARTMENT': 'department_id',
    'PROVIDER': 'provider_id',
    'PHYSICIANS GROUP': 'physicians_group_id'
})

const userTypeKeysToEnum = Object.freeze({
    'health_system_id': ClientType.HEALTH_SYSTEM,
    'hospital_id': ClientType.HOSPITAL,
    'department_id': ClientType.DEPARTMENT,
    'provider_id': ClientType.PROVIDER,
    'physicians_group_id': ClientType.PHYSICIANS_GROUP
})

const getCurrentClientType = user_type => {
    return userTypeToEnumMapping[user_type] ?
     userTypeToEnumMapping[user_type]: ClientType.UNDEFINED;
};

const getDictionaryKeyForClientTypeData = user_type => {
    return userTypeToDictionaryKeyMapping[user_type] ?
    userTypeToDictionaryKeyMapping[user_type] : ClientType.UNDEFINED; 
}

export { getCurrentClientType, ClientType, getDictionaryKeyForClientTypeData, userTypeKeysToEnum }